import React from 'react';
import { Grid, InputLabel } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import { InputItem } from '@components/Input/Inputs';
import useUserActionLog, {
  Enum_Action_Button_Enum,
  CapaActivityType
} from '@hooks/useUserActionLog';
import { useFormContext } from 'react-hook-form';
import { useStyles } from './styles';

const PasswordInput: React.FC = () => {
  const { onInsertUserActionLogOne } = useUserActionLog();
  const { passwordLabelBox, inputContainer } = useStyles();
  const { register, errors, clearErrors } = useFormContext();

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={passwordLabelBox}
      >
        <InputLabel>비밀번호</InputLabel>
        <CustomizedTypography variant="body2" fontWeight="normal">
          영문+숫자 조합 8글자 이상
        </CustomizedTypography>
      </Grid>
      <Grid className={inputContainer}>
        <InputItem
          errors={errors}
          name="password"
          inputProps={{
            placeholder: '영문+숫자 조합 8글자 이상',
            onFocus: () => {
              onInsertUserActionLogOne(
                Enum_Action_Button_Enum.Button_SignUp_Password,
                CapaActivityType.ButtonClick
              );
            },
            onChange: () => {
              clearErrors('password');
            },
            autoComplete: 'new-password',
            ref: register({
              required: true
            })
          }}
        />
      </Grid>
    </>
  );
};

export default PasswordInput;
